import AsyncSelect from "@/app/_components/share/AsyncSelect";
import DateInputField from "@/app/_components/share/DateInputField";
import { getJobDuty } from "@/services/api/masterData";
import {
  Divider,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  IconButton,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaTrash } from "react-icons/fa6";

export default function WorkExperienceBox({
  index = "",
  values = {},
  onChange = () => {},
  onRemoveClick = () => {},
}) {
  const { t } = useTranslation();

  const handleInputChange = (e) => {
    onChange({ [e.target.name]: e.target.value });
  };

  return (
    <Stack gap={6}>
      {index > 0 && <Divider />}
      <Stack>
        <HStack
          w="full"
          py={2}
          pl={4}
          pr={2}
          bgColor="main"
          rounded="md"
          justifyContent="space-between"
        >
          <Text>#{index + 1}</Text>
          <IconButton
            h={6}
            w="fit-content"
            p={0}
            variant="ghost"
            icon={<FaTrash />}
            onClick={() => onRemoveClick(index)}
          />
        </HStack>
        <Grid templateColumns="repeat(2, 1fr)" gap={3}>
          <GridItem colSpan={2}>
            <FormControl isRequired>
              <FormLabel>{t("Company Name")}</FormLabel>
              <Input
                name="companyName"
                value={values.companyName}
                onChange={handleInputChange}
              />
            </FormControl>
          </GridItem>
          <GridItem colSpan={2}>
            <FormControl isRequired>
              <FormLabel>{t("Position")}</FormLabel>
              <AsyncSelect
                queryKey="workExpPosition"
                apiCall={getJobDuty}
                name="position"
                placeholder={t("--Select--")}
                value={values?.position}
                onChange={handleInputChange}
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>{t("Period")}</FormLabel>
              <DateInputField
                name="startPeriod"
                format="yyyy/MM"
                placeholder={t("Start date(YYYY/MM)")}
                value={values.startPeriod}
                onChange={(date) => onChange({ startPeriod: date })}
                max={values.endPeriod || new Date()}
                showMonthYearPicker
              />
            </FormControl>
          </GridItem>
          <GridItem display="flex" alignItems="end">
            <FormControl isRequired>
              <DateInputField
                name="endPeriod"
                format="yyyy/MM"
                placeholder={t("End date(YYYY/MM)")}
                value={values.endPeriod}
                onChange={(date) => onChange({ endPeriod: date })}
                min={values.startPeriod}
                max={new Date()}
                showMonthYearPicker
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Stack>
    </Stack>
  );
}
